import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    container: {
        height: "100%",
        width: "100%",
        display: "flex",
        gap: theme.spacing(4),
        alignItems: "center",
        justifyContent: "center",
        background: theme.palette.backgrounds.main,
        padding: `${theme.spacing(2.5)} 0`,
    },
    text: {
        color: theme.palette.primary.dark,
    },
    icon: {
        height: "40px !important",
        width: "40px !important",
        color: theme.palette.primary.dark,
    },
}));
